$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.el-element-variants').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});




$(document).on("click", ".el-pdp2-works-grid-item", function (e) {
    $('.el-pdp2-works-grid-item').removeClass('el-active');
    $(this).addClass('el-active');
    var tab_index = $(this).index() + 1;
     $('.el-pdp2-works-tab').removeClass('el-active');
     $('.el-pdp2-works-tab'+tab_index).addClass('el-active');
});











$(document).on("click", ".el-cart-button", function (e) {
  $('.amp-cart').addClass('amp-cart--open');
});


$(document).on("click", ".amp-cart-drawer__overlay, button.amp-cart__header-close-button", function (e) {
  $('.amp-cart').removeClass('amp-cart--open');
});





$(document).on('click', '.el-element-variant', function (e) {
  e.preventDefault();
  e.stopPropagation(); // not immediate
  var $this = $(this);
  var variant_id = $this.attr('variant_id');
  var selling_plan = $this.attr('selling_plan');

  if (!variant_id) return;

  // Remove active from siblings
  $('.el-element-variant').removeClass('el-active');
  // Add active to current
  $this.addClass('el-active');

$('.el-variant-trigger').hide().removeClass('el-active');
$('.el-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('el-active');
$('.el-checkout-button').attr('variant_id',variant_id);


  if (selling_plan) {
$('.el-checkout-button').attr('selling_plan',selling_plan);
  } else {
$('.el-checkout-button').removeAttr('selling_plan',);
  }
});



$(document).on('click', '.el-element-sub-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.el-element-sub-option').removeClass('el-active');

  // Add active to current
  $this.addClass('el-active');

$('.el-sub-trigger').hide();
$('.el-sub-trigger[sub_tab="'+tab+'"]').show();
var selling_plan = $('.el-element-variant.el-active').attr('selling_plan');
if(tab == 1){
$('.el-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.el-checkout-button').removeAttr('selling_plan',);
}
});






  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.el-expect-grid-item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('el-active');
        } else {
          $(this).removeClass('el-active');
        }
    });
    $('.el-technology-list ul li').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('el-active');
        } else {
          $(this).removeClass('el-active');
        }
    });
});



